const SET_USERS = 'SET_USERS';
const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
const SET_LOADING = 'SET_USERS_LOADING';
const SET_PAGE = 'SET_USERS_PAGE';
const SET_ROWS_PER_PAGE = 'SET_USERS_ROWS_PER_PAGE';
const SET_SEARCH_TERM = 'SET_USERS_SEARCH_TERM';

export default {
    SET_USERS,
    SET_TOTAL_COUNT,
    SET_LOADING,
    SET_PAGE,
    SET_ROWS_PER_PAGE,
    SET_SEARCH_TERM
};
